import { useMemo } from 'react';

import { ServicesManager } from '@core';
import { LocalForageKey, Preset } from 'types';
import { useGetDisplaysetModality } from './useGetDisplaysetModality';
import useLocalforage from './useLocalForage';

export const useGetPresetData = (serviceManager: ServicesManager, isGetPresetByModality: boolean) => {
	const modality = useGetDisplaysetModality(serviceManager);
	const [presetData] = useLocalforage<Preset[]>(LocalForageKey['Preset'], []);

	const presetByModality = useMemo(() => {
		if (isGetPresetByModality) {
			const data = presetData ?? [];
			return data.filter((item) => {
				if (!item) {
					return false;
				}
				if (item.modality === 'DX' && (modality === 'CR' || modality === 'DR')) {
					return true;
				}
				return item.modality.includes(modality) || item.modality === 'ALL';
			});
		}
		return presetData;
	}, [isGetPresetByModality, modality, presetData]);

	return presetByModality;
};
